<template>
  <div class="withdraw-container">
    <el-card shadow="hover" class="withdraw-card">
      <template #header>
        <div class="card-header">
          <div class="header-line"></div>
          <h3 class="header-title">提现信息设置</h3>
        </div>
      </template>

      <el-form :model="form" :rules="rules" ref="formRef" label-width="100px" class="withdraw-form">

        <el-form-item label="姓名" prop="name">
          <el-input v-model="form.name" placeholder="请输入姓名" :disabled="isEditDisabled"/>
        </el-form-item>

        <el-form-item label="电话" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入手机号" :disabled="isEditDisabled"/>
        </el-form-item>

        <el-form-item label="身份证号" prop="idCard">
          <el-input v-model="form.idCard" placeholder="请输入身份证号" :disabled="isEditDisabled"/>
        </el-form-item>

        <el-form-item label="提现方式" prop="type">
          <el-select 
            v-model="form.type" 
            placeholder="请选择提现方式" 
            style="width: 100%"
            :disabled="isEditDisabled">
            <el-option label="支付宝" value="alipay"/>
            <el-option label="银行卡" value="bank"/>
          </el-select>
        </el-form-item>

        <template v-if="form.type === 'alipay'">
          <el-form-item label="支付宝账号" prop="alipayAccount">
            <el-input 
              v-model="form.alipayAccount" 
              placeholder="请输入支付宝账号"
              :disabled="isEditDisabled"/>
          </el-form-item>
        </template>

        <template v-if="form.type === 'bank'">
          <el-form-item label="银行名称" prop="bankName">
            <el-select 
              v-model="form.bankName" 
              placeholder="请选择银行" 
              style="width: 100%"
              :disabled="isEditDisabled">
              <el-option v-for="bank in bankList" :key="bank.value" :label="bank.label" :value="bank.value"/>
            </el-select>
          </el-form-item>

          <el-form-item label="银行卡号" prop="bankCard">
            <el-input 
              v-model="form.bankCard" 
              placeholder="请输入银行卡号"
              :disabled="isEditDisabled"/>
          </el-form-item>
        </template>

        <el-form-item>
          <el-button 
            type="primary" 
            @click="submitForm"
            class="submit-btn"
            :disabled="isEditDisabled">
            {{ isEditDisabled ? '信息已保存' : '保存信息' }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'WithdrawInfo',
  data() {
    return {
      form: {
        name: '',
        phone: '',
        idCard: '',
        type: 'alipay',
        alipayAccount: '',
        bankName: '',
        bankCard: ''
      },
      isEditDisabled: false,
      bankList: [
        { label: '中国工商银行', value: 'ICBC' },
        { label: '中国建设银行', value: 'CCB' },
        { label: '中国银行', value: 'BOC' },
        { label: '中国农业银行', value: 'ABC' },
        { label: '招商银行', value: 'CMB' }
      ],
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
        ],
        idCard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { pattern: /^\d{17}[\dXx]$/, message: '身份证号格式不正确', trigger: 'blur' }
        ],
        alipayAccount: [
          { required: true, message: '请输入支付宝账号', trigger: 'blur' },
          {
            pattern: /^1[3-9]\d{9}$|^\w+@\w+\.\w+$/,
            message: '请输入手机号或邮箱格式的支付宝账号',
            trigger: 'blur'
          }
        ],
        bankName: [
          { required: true, message: '请选择银行', trigger: 'change' }
        ],
        bankCard: [
          { required: true, message: '请输入银行卡号', trigger: 'blur' },
          { pattern: /^\d{16,19}$/, message: '银行卡号格式不正确', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.feachData()
  },
  methods: {
    feachData() {
      this.$axios.get('/api/Bloger/getwithdrawinfo')
        .then(response => {
          this.form = response.data || this.form
          this.isEditDisabled = !!(response.data?.alipayAccount || response.data?.bankCard)
        })
        .catch(err => {
          this.$message.error('获取提现信息失败: ' + err.message)
        })
    },
    submitForm() {
      if (!this.form.type) {
        this.$message.error('请选择提现方式')
        return
      }
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        
        const formData = { ...this.form }
        this.$axios.post('/api/Bloger/savewithdrawinfo', formData, {
          transformRequest: [data => JSON.stringify(data)],
          headers: { 'Content-Type': 'application/json' }
        })
        .then(res => {
          if (res.code == 1) {
            this.$message.success('提现信息保存成功')
            this.feachData()
          } else {
            this.$message.error('保存失败: ' + res.msg)
          }
        })
        .catch(err => {
          this.$message.error('保存失败: ' + (err.response?.data?.message || err.message))
        })
      })
    }
  }
}
</script>

<style scoped>
.withdraw-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: calc(100vh - 60px);
}

.withdraw-card {
  border-radius: 8px;
  border: none;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  max-width: 800px;
  margin: 0 auto;
}

.card-header {
  display: flex;
  align-items: center;
  padding: 10px 0;
}

.header-line {
  width: 4px;
  height: 20px;
  background: linear-gradient(to bottom, #409EFF, #67C23A);
  border-radius: 2px;
  margin-right: 10px;
}

.header-title {
  margin: 0;
  font-size: 18px;
  color: #303133;
  font-weight: 600;
}

.withdraw-form {
  padding: 0 20px;
}

.el-form-item {
  margin-bottom: 22px;
}

.submit-btn {
  width: 200px;
  height: 40px;
  font-size: 16px;
  border-radius: 20px;
  box-shadow: 0 2px 6px rgba(64, 158, 255, 0.3);
  transition: all 0.3s;
  display: block;
  margin: 0 auto;
}

.submit-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
}
</style>
